import React from 'react';
import App from './App';

const AppWrapper = () => {
    return <App />;
};

export default AppWrapper;
